import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * TrailingSlashRedirect
 * 
 * Enforces NO trailing slashes on all URLs (except homepage "/").
 * Redirects /about/ → /about, /blog/ → /blog, etc.
 */
export const TrailingSlashRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const { pathname, search, hash } = location;

    // Skip root path
    if (pathname === "/") return;

    // Skip paths that look like files (have extensions)
    if (/\.\w+$/.test(pathname)) return;

    // Remove trailing slash if present
    if (pathname.endsWith("/")) {
      const cleanPath = pathname.slice(0, -1);
      navigate(`${cleanPath}${search}${hash}`, { replace: true });
    }
  }, [location, navigate]);

  return null;
};
